module.exports = __webpack_public_path__ + "img/icono-millas.0a6a9b8d.svg";